var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalCash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 192,
    height: 192,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,8H4c-1.105,0-2,0.895-2,2v6h20v-6C22,8.895,21.105,8,20,8z",
    opacity: 0.35,
    fill: "#66B2B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20,6H4C2.895,6,2,6.895,2,8v2c0-1.105,0.895-2,2-2h16c1.105,0,2,0.895,2,2V8C22,6.895,21.105,6,20,6z",
    fill: "#66B2B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20,4H4C2.895,4,2,4.895,2,6v2c0-1.105,0.895-2,2-2h16c1.105,0,2,0.895,2,2V6C22,4.895,21.105,4,20,4z",
    opacity: 0.35,
    fill: "#66B2B2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15,12c0,1.657-1.343,3-3,3s-3-1.343-3-3H2v5c0,1.657,1.343,3,3,3h14c1.657,0,3-1.343,3-3v-5H15z",
    fill: "#66B2B2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalCash);
export default __webpack_public_path__ + "static/media/total-cash.22467affe2f867be0bd898bbd5fe9e29.svg";
export { ForwardRef as ReactComponent };